
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IDongBoHinhThucThiRequest } from "../../../model/request/tct/IDongBoHinhThucThiRequest";
import { IMonThiAddLopTinChiRequest } from "../../../model/request/tct/IMonThiAddLopTinChiRequest";
import { IMonThi } from "../../../model/respone/tct/IMonThi";
import { IMonThiVm } from "../../../model/respone/tct/IMonThiVm";
import { IMonThiFilter } from "../../reducer-model/tct/IMonThiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IMonThiActionTypeBase<T> {
    dotThiId: number,
    data: T
}
export const eMonThiActionsObj = {
    CHANGE_DOT_THI_ID: {} as IMonThiActionTypeBase<undefined>,

    LOAD_START: {} as IMonThiActionTypeBase<undefined>,
    LOAD_SUCCESS: {} as IMonThiActionTypeBase<IMonThiVm[]>,
    LOAD_ERROR: {} as IMonThiActionTypeBase<string>,

    SHOW_EDIT_MODAL: {} as IMonThiActionTypeBase<IMonThiVm | undefined>,
    CLOSE_EDIT_MODAL: {} as IMonThiActionTypeBase<undefined>,

    SAVE_START: {} as IMonThiActionTypeBase<IMonThi>,
    SAVE_SUCCESS: {} as IMonThiActionTypeBase<IMonThi>,
    SAVE_ERROR: {} as IMonThiActionTypeBase<string>,

    DELETE_START: {} as IMonThiActionTypeBase<IIdsRequest>,
    DELETE_SUCCESS: {} as IMonThiActionTypeBase<undefined>,
    DELETE_ERROR: {} as IMonThiActionTypeBase<string>,

    SHOW_ADD_MONTHI_MODAL: {} as IMonThiActionTypeBase<number|undefined>,
    CLOSE_ADD_MONTHI_MODAL: {} as IMonThiActionTypeBase<undefined>,

    ADD_LOP_TIN_CHI_START: {} as IMonThiActionTypeBase<IMonThiAddLopTinChiRequest>,
    ADD_LOP_TIN_CHI_SUCCESS: {} as IMonThiActionTypeBase<undefined>,
    ADD_LOP_TIN_CHI_ERROR: {} as IMonThiActionTypeBase<string>,

    CHANGE_SELECTED_IDS: {} as IMonThiActionTypeBase<number[]>,
    CHANGE_MONHOC_IDS_SELECTED: {} as IMonThiActionTypeBase<number[]>,
    CHANGE_MONHOC_ID_FOCUSED: {} as IMonThiActionTypeBase<number>,

    UPDATES_START: {} as IMonThiActionTypeBase<IMonThi[]>,
    UPDATES_SUCCESS: {} as IMonThiActionTypeBase<IMonThi[]>,
    UPDATES_ERROR: {} as IMonThiActionTypeBase<string>,

    ADD_MON_THI_START: {} as IMonThiActionTypeBase<IMonThi[]>,
    ADD_MON_THI_SUCCESS: {} as IMonThiActionTypeBase<undefined>,
    ADD_MON_THI_ERROR: {} as IMonThiActionTypeBase<string>,

    SYS_HINH_THUC_THI_START: {} as IMonThiActionTypeBase<IDongBoHinhThucThiRequest>,
    SYS_HINH_THUC_THI_SUCCESS: {} as IMonThiActionTypeBase<undefined>,
    SYS_HINH_THUC_THI_ERROR: {} as IMonThiActionTypeBase<string>,

    CHANGE_FILTER: {} as IMonThiActionTypeBase<IMonThiFilter>,
};
export const eMonThiActionIds = generateActionTypeIds(
    eMonThiActionsObj,
    "MON_THI"
);
export type IMonThiActionTypes = IGenericActionType<
    typeof eMonThiActionsObj,
    "MON_THI"
>;
